import './css/variables.css';
import './css/base.css';
import './css/glass-components.css';
import './css/animations.css';
import './css/sections.css';
import './css/portfolio.css';
import './css/brand-theme.css';

import { ScrollAnimationEngine } from './js/animations/scroll-engine.js';
import './js/theme.js';
import './js/portfolio.js';

// Developer profiles shown in the portfolio leaderboard.
const developers = [
  {
    name: 'Adeel Ejaz',
    role: 'Web & App Developer',
    score: 99,
    shipped: '3 years',
    color: 'pink',
    bio: 'Adeel Ejaz is a Web & App Developer with three years of experience. He specializes in web and app development, building websites and applications.',
    focus: ['Web development', 'App development'],
    experience: '3 years'
  },
  {
    name: 'Muhammad Usman Younas',
    role: 'AI Engineer & Full-Stack Developer',
    score: 98,
    shipped: '3 years',
    color: 'cyan',
    bio: 'Muhammad Usman Younas is an AI Engineer and Full-Stack Developer with three years of professional experience at ZAMH Technologies. He works across intelligent automation, autonomous AI agents, RAG-based systems, API services, and modern full-stack web applications. His approach combines practical architecture, thorough testing, collaborative delivery, and a consistent focus on reliable production results.',
    focus: ['Autonomous AI agents', 'RAG & LLM systems', 'Full-stack APIs', 'Testing & delivery'],
    experience: '3 years'
  },
  {
    name: 'Muhammad Ramzan',
    role: 'AI Engineer & Full-Stack Developer',
    score: 95,
    shipped: '3 years',
    color: 'violet',
    bio: 'Muhammad Ramzan is an AI Engineer and Full-Stack Developer with three years of professional experience at ZAMH Technologies. He contributes to the development of AI-powered products, conversational interfaces, data-driven workflows, and responsive web platforms. He brings careful engineering judgment to implementation, integration, testing, and the dependable delivery of maintainable software.',
    focus: ['AI-powered products', 'Chatbot integrations', 'Responsive platforms', 'Quality engineering'],
    experience: '3 years'
  },
  {
    name: 'Hasnain Fiaz',
    role: 'Web & App Developer',
    score: 93,
    shipped: '3 years',
    color: 'blue',
    bio: 'Hasnain Fiaz is a Mobile and Web Application Developer with three years of professional experience at ZAMH Technologies. He builds reliable Flutter and React applications, responsive web experiences, and user-focused product interfaces. His work covers application architecture, API integration, testing, performance, and delivery, with a strong commitment to quality and dependable teamwork.',
    focus: ['Flutter & React apps', 'Responsive web UI', 'API integration', 'Performance & testing'],
    experience: '3 years'
  }
];

const initials = (name) => name.split(' ').map((part) => part[0]).join('');

function renderDeveloperLeague() {
  const podium = document.getElementById('developer-podium');
  const table = document.getElementById('developer-table');
  if (!podium || !table) return;

  const podiumOrder = [developers[1], developers[0], developers[2]];
  podium.innerHTML = podiumOrder.map((developer, index) => {
    const place = index === 1 ? 1 : index === 0 ? 2 : 3;
    return `
      <article class="developer-podium-card place-${place} accent-${developer.color}" data-developer-id="${developers.indexOf(developer)}" tabindex="0" role="button" aria-label="Open profile for ${developer.name}">
        <div class="developer-medal">${place}</div>
        <div class="developer-avatar">${initials(developer.name)}</div>
        <span class="developer-place">${place === 1 ? 'Current leader' : `Ranked #${place}`}</span>
        <h3>${developer.name}</h3>
        <p>${developer.role}</p>
        <strong>${developer.score}</strong>
        <span class="developer-points">impact points</span>
      </article>
    `;
  }).join('');

  table.innerHTML = developers.map((developer, index) => `
    <div class="developer-row" data-developer-id="${index}" tabindex="0" role="button" aria-label="Open profile for ${developer.name}">
      <div class="developer-identity">
        <span class="developer-rank">${String(index + 1).padStart(2, '0')}</span>
        <div class="developer-avatar small accent-${developer.color}">${initials(developer.name)}</div>
        <div><strong>${developer.name}</strong><span>${developer.shipped}</span></div>
      </div>
      <span class="developer-role">${developer.role}</span>
      <div class="developer-score"><span>${developer.score}</span><i><b style="width: ${developer.score}%"></b></i></div>
    </div>
  `).join('');

  const openProfile = (developerId) => {
    const developer = developers[developerId];
    const modal = document.getElementById('developer-modal');
    const body = document.getElementById('developer-modal-body');
    if (!developer || !modal || !body) return;

    body.innerHTML = `
      <div class="developer-profile-head">
        <div class="developer-avatar profile-avatar accent-${developer.color}">${initials(developer.name)}</div>
        <div>
          <span class="section-tag">Developer profile</span>
          <h2 id="developer-modal-title">${developer.name}</h2>
          <p>${developer.role}</p>
        </div>
      </div>
      <p class="developer-profile-bio">${developer.bio}</p>
      <div class="developer-profile-stats">
        <div><strong>${developer.score}</strong><span>Impact score</span></div>
        <div><strong>${developer.shipped}</strong><span>Tenure</span></div>
        <div><strong>${developer.experience}</strong><span>Experience</span></div>
      </div>
      <div class="developer-focus-list">
        <span>Core focus</span>
        <div>${developer.focus.map((item) => `<span class="pill-badge">${item}</span>`).join('')}</div>
      </div>
    `;
    modal.classList.add('active');
  };

  document.querySelectorAll('[data-developer-id]').forEach((developerCard) => {
    const activate = () => openProfile(Number(developerCard.dataset.developerId));
    developerCard.addEventListener('click', activate);
    developerCard.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activate();
      }
    });
  });

  const modal = document.getElementById('developer-modal');
  const closeButton = document.getElementById('developer-modal-close');
  const closeModal = () => modal?.classList.remove('active');
  closeButton?.addEventListener('click', closeModal);
  modal?.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  renderDeveloperLeague();
  new ScrollAnimationEngine();

  const mobileToggle = document.getElementById('mobile-toggle');
  const navMenu = document.getElementById('nav-menu');
  if (mobileToggle && navMenu) {
    mobileToggle.addEventListener('click', () => navMenu.classList.toggle('active'));
    navMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => navMenu.classList.remove('active'));
    });
  }

  const navbar = document.getElementById('navbar');
  const updateNavbarState = () => navbar?.classList.toggle('scrolled', window.scrollY > 120);
  window.addEventListener('scroll', updateNavbarState, { passive: true });
  updateNavbarState();
});
